"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Sample_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/Sample"));
const FlatSample_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/FlatSample"));
const randomItem_1 = __importDefault(require("@common/tsutils/randomItem"));
const GROUP_COLORS = ['#d98e7a', '#3fb8b2', '#6C3FB8', '#DB756F', '#CF8944', '#E6C93B', '#3D9970', '#85144b', '#FF851B', '#39CCCC', '#01FF70', '#FFDC00', '#001f3f', '#0074D9'];
class Group {
    constructor(name, parent = null) {
        this.name = '';
        this.color = (0, randomItem_1.default)(GROUP_COLORS);
        this.parent = null;
        this.groups = null;
        this.samples = null;
        // The config instance applied to this group
        this.groupConfigInstance = null;
        this.orderConfigInstance = null;
        this.name = name;
        this.parent = parent;
        this.level = parent ? parent.level + 1 : 0;
    }
    maxLevel() {
        if (this.samples) {
            return this.level;
        }
        if (!this.groups)
            return 0;
        const levels = this.groups.map(g => g.maxLevel());
        return Math.max(...levels);
    }
    childIdx(child) {
        if (child instanceof Sample_1.default && this.samples) {
            return this.samples.indexOf(child);
        }
        if (child instanceof Group && this.groups) {
            return this.groups.indexOf(child);
        }
        return -1;
    }
    /**
     * The offset within the group measured by the number of samples
     * @param child
     */
    childOffset(child) {
        if (child instanceof Sample_1.default && this.samples) {
            return this.samples.indexOf(child);
        }
        if (child instanceof Group && this.groups) {
            let offset = 0;
            for (const g of this.groups) {
                if (g === child)
                    return offset;
                offset += g.numSamplesRecursive();
            }
        }
        return -1;
    }
    /**
     * With of the child measured by the number of samples
     * @param child
     */
    childWidth(child) {
        if (child instanceof Sample_1.default && this.samples) {
            return 1;
        }
        if (child instanceof Group && this.groups) {
            for (const g of this.groups) {
                if (g === child)
                    return g.numSamplesRecursive();
            }
        }
        return -1;
    }
    childs() {
        if (this.samples)
            return this.samples;
        if (this.groups)
            return this.groups;
        throw "Invalid child";
    }
    child(i) {
        return this.childs()[i];
    }
    moveChild(idx, newIdx) {
        if (this.samples) {
            this.moveChildSample(idx, newIdx);
        }
        else if (this.groups) {
            this.moveChildGroup(idx, newIdx);
        }
        else {
            throw "Invalid samples/groups";
        }
    }
    moveChildSample(idx, newIdx) {
        if (!this.samples)
            throw "No samples in moveChildSample";
        const item = this.samples.splice(idx, 1);
        this.samples.splice(newIdx, 0, item[0]);
        if (this.orderConfigInstance) {
            this.orderConfigInstance.direction = 'manual';
        }
    }
    moveChildGroup(idx, newIdx) {
        if (!this.groups)
            throw "No groups in moveChildGroup";
        const item = this.groups.splice(idx, 1);
        this.groups.splice(newIdx, 0, item[0]);
        console.log("Moving groupsss");
        if (this.groupConfigInstance) {
            console.log("Set groupConfigInstance direction as manual ");
            this.groupConfigInstance.direction = 'manual';
        }
    }
    get length() {
        if (this.samples)
            return this.samples.length;
        if (this.groups)
            return this.groups.length;
        return 0;
    }
    numSamplesRecursive() {
        if (this.samples)
            return this.samples.length;
        if (this.groups)
            return this.groups.reduce((acc, g) => acc + g.numSamplesRecursive(), 0);
        return 0;
    }
    flatSamples() {
        var _a;
        if (this.samples) {
            return this.samples.map((s, i) => {
                const flat = new FlatSample_1.default(s);
                if (this.level === 0) {
                    flat.group = null;
                    flat.subgroup = null;
                }
                else if (this.level === 1) {
                    flat.group = this;
                    flat.subgroup = null;
                }
                else {
                    flat.group = this.parent;
                    flat.subgroup = this;
                }
                return flat;
            });
        }
        let flats = [];
        (_a = this.groups) === null || _a === void 0 ? void 0 : _a.forEach(g => {
            flats = [...flats, ...g.flatSamples()];
        });
        return flats;
    }
    toConfiguration() {
        var _a, _b;
        return {
            name: this.name,
            color: this.color,
            groups: (_a = this.groups) === null || _a === void 0 ? void 0 : _a.map(g => g.toConfiguration()),
            samples: (_b = this.samples) === null || _b === void 0 ? void 0 : _b.map(s => ({ code: s.code })),
        };
    }
}
exports.default = Group;
